import React from 'react';
import DesktopHeader from '../../Header/DesktopHeader';
import SpinnerBlock from '../../../common/SpinnerBlock';
import ItemList from '../ItemList';
import DesktopHistoryBlock from '../HistoryBlock/DesktopHistoryBlock';
import SupplierBlock from '../SupplierBlock';
import ConsignorBlock from '../ConsignorBlock';
import WarehouseBlock from '../WarehouseBlock';
import OtherBlock from '../OtherBlock';
import styled from '@emotion/styled';
import AcceptanceSettingsBlock from '../AcceptanceSettingsBlock';
import WorksheetBlock from '../WorksheetBlock';

const Wrapper = styled('div')`
  .block-subtitle {
    color: #98a6ad;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .change-link {
    color: #7e57c2;
    cursor: pointer;
  }
  .border-top {
    border-top: 1px solid #ccc;
    padding-top: 10px;
  }
  .block-subtitle {
    color: #98a6ad;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .editable-input input {
    width: 80px;
  }

  .right-blocks {
    flex: 0 0 25%;
    max-width: 50%;
    padding-left: 15px;
  }

  .content-block {
    flex: 0 0 75%;
    max-width: 75%;
  }

  .history-mobile {
    display: none;
  }

  @media (max-width: 1244px) {
    .content-block {
      flex: 1;
      max-width: 100%;
    }
    .right-blocks {
      display: grid;
      grid-template-columns: 1fr 1fr;
      flex: 1;
      max-width: 100%;
      grid-column-gap: 24px;
      padding-left: 0;
    }

    .history-mobile {
      display: block;
    }

    .history-desktop {
      display: none;
    }
  }

  @media (max-width: 576px) {
    .right-blocks {
      display: grid;
      grid-template-columns: 1fr;
      flex: 1;
      max-width: 100%;
      grid-row-gap: 20px;
      padding: 0 12px;
    }
  }
`;

const DesktopLayout = (props) => {
  const {
    isNew,
    getCurrentSupply,
    currentSupply,
    currentWarehouse,
    saveSupply,
    setQuantityFactChange,
    supplyHistory,
    handleWarehouseChange,
    isSupplyClosed,
    otherBlockRef,
    supplyCustomId,
    setSupplyCustomId,
  } = props;

  return (
    <>
      <DesktopHeader supplyCustomId={supplyCustomId} setSupplyCustomId={setSupplyCustomId} />
      <Wrapper>
        {/* <SpinnerBlock show={getCurrentSupply.isFetching} /> */}
        {currentSupply ? (
          <>
            <div className="row">
              <div className="content-block">
                <ItemList
                  currentWarehouse={currentWarehouse}
                  handleSaveSupply={saveSupply}
                  setQuantityFactChange={setQuantityFactChange}
                />
                {supplyHistory && supplyHistory.length ? (
                  <div className="history-desktop">
                    <DesktopHistoryBlock supplyHistory={supplyHistory} />
                  </div>
                ) : null}
              </div>
              <div className="right-blocks">
                <SupplierBlock />
                <WarehouseBlock
                  currentWarehouse={currentWarehouse}
                  handleChange={handleWarehouseChange}
                  isSupplyClosed={isSupplyClosed}
                  currentSupply={currentSupply}
                />
                <OtherBlock isNew={isNew} ref={otherBlockRef} />
                <ConsignorBlock />
                <AcceptanceSettingsBlock />
              </div>
            </div>

            {supplyHistory && supplyHistory.length ? (
              <div className="history-mobile">
                <DesktopHistoryBlock supplyHistory={supplyHistory} />
              </div>
            ) : null}
          </>
        ) : null}
      </Wrapper>
    </>
  );
};

export default DesktopLayout;
